"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateHeaderFooter = exports.useCreateHeaderFooter = exports.useFetchHeaderFooter = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const headerFooterAction_1 = require("./headerFooterAction");
const useFetchHeaderFooter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const headerFooterFetchLoading = (0, react_redux_1.useSelector)((State) => State['headerFooter/fetch'].loading);
    const headerFooterFetchError = (0, react_redux_1.useSelector)((State) => State['headerFooter/fetch'].error);
    const headerFooterFetchData = (0, react_redux_1.useSelector)((State) => State['headerFooter/fetch'].data);
    const fetchHeaderFooter = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, headerFooterAction_1.fetch)(payload));
    });
    return {
        headerFooterFetchLoading,
        headerFooterFetchError,
        headerFooterFetchData,
        fetchHeaderFooter
    };
};
exports.useFetchHeaderFooter = useFetchHeaderFooter;
const useCreateHeaderFooter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const headerFooterCreateLoading = (0, react_redux_1.useSelector)((State) => State['headerFooter/create'].loading);
    const headerFooterCreateError = (0, react_redux_1.useSelector)((State) => State['headerFooter/create'].error);
    const headerFooterCreateData = (0, react_redux_1.useSelector)((State) => State['headerFooter/create'].data);
    const createHeaderFooter = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, headerFooterAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to create Header & Footer");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        headerFooterCreateLoading,
        headerFooterCreateError,
        headerFooterCreateData,
        createHeaderFooter
    };
};
exports.useCreateHeaderFooter = useCreateHeaderFooter;
const useUpdateHeaderFooter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const headerFooterUpdateLoading = (0, react_redux_1.useSelector)((State) => State['headerFooter/update'].loading);
    const headerFooterUpdateError = (0, react_redux_1.useSelector)((State) => State['headerFooter/update'].error);
    const headerFooterUpdateData = (0, react_redux_1.useSelector)((State) => State['headerFooter/update'].data);
    const updateHeaderFooter = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, headerFooterAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to update Header & Footer");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        headerFooterUpdateLoading,
        headerFooterUpdateError,
        headerFooterUpdateData,
        updateHeaderFooter
    };
};
exports.useUpdateHeaderFooter = useUpdateHeaderFooter;
